import Phaser from 'phaser';
import WebFontFile from '../../../../utils/PhaserWebFontLoader';
import { session, client } from '../../../../utils/nakama';

export default class Load extends Phaser.Scene {
    constructor() {
        super({
            key: 'Load'
        });
    }

    async loadFont(name, url) {
        try {
            var newFont = new FontFace(name, `url(${url})`);
            const loaded = await newFont.load();
            await document.fonts.add(loaded);
        } catch(error) {
            console.error(error);
            return error;
        };
    }

    isSafariNotChromeOrChromium(str) {
        return str.includes('Safari') && !str.includes('Chrome') && !str.includes('Chromium');
    }

    async getDailyRewardStatus() {
        try {
            const res = await client.rpc(session, "checkdailyreward", {"request": "getStatus"});
            return res.payload;
        } catch (error) {
            console.error("get_daily_bonus_status", error);
        }
    }

    preload() {
        //Load fonts
        this.load.addFile(new WebFontFile(this.load, 'Truculenta'));

        //image for button
        this.load.image('greenButton', 'https://zoombies.world/images/dapp/green_button_400.webp');

        //Load all the cards atlas
        this.load.atlas('card_images', '/bonez/images/cards_atlas.webp', '/bonez/images/cards_atlas.json');

        //Load all the cards atlas
        this.load.atlas('bonus_images', '/bonez/images/bonus_atlas.webp', '/bonez/images/bonus_atlas.json');

        // //background image
        // this.load.image('DailyBonusBg', '/bonez/images/daily_bonus_bg.png');
        // //image for the daily bonus
        // this.load.image('day1', '/bonez/images/pile_of_bonez.png');
        // this.load.image('day2', '/bonez/images/crate_of_bonez_small.png');
        // this.load.image('day3', '/bonez/images/crate_of_bonez.png');
        // this.load.image('day4', '/bonez/images/crate_of_bonez_large.png');
        // this.load.image('day5', '/bonez/images/bonez_mystery_bag.png');
        // this.load.image('claimed', '/bonez/images/claimed.png');
        
        // //card images
        // this.load.image("plus_neg_1", "/bonez/images/cards/power-cards/plus_neg_1.svg");
        // this.load.image("plus_neg_2", "/bonez/images/cards/power-cards/plus_neg_2.svg");
        // this.load.image("plus_neg_3", "/bonez/images/cards/power-cards/plus_neg_3.svg");
        // this.load.image("plus_neg_4", "/bonez/images/cards/power-cards/plus_neg_4.svg");
        // this.load.image("plus_neg_5", "/bonez/images/cards/power-cards/plus_neg_5.svg");
        // this.load.image("plus_neg_6", "/bonez/images/cards/power-cards/plus_neg_6.svg");
        // this.load.image("1_or_11", "/bonez/images/cards/power-cards/1_or_11.svg");
        // this.load.image("double", "/bonez/images/cards/power-cards/double.svg");
        // this.load.image("redraw", "/bonez/images/cards/power-cards/redraw.svg");
        // this.load.image("resurrect", "/bonez/images/cards/power-cards/resurrect.svg");
        // this.load.image("steal", "/bonez/images/cards/power-cards/steal.svg")
        // this.load.image("tie_breaker", "/bonez/images/cards/power-cards/tie_breaker.svg");

        //vfx images
        this.load.image("xp", "/bonez/images/xp.png");
        this.load.image("bone", "/bonez/images/bone.webp");

        //Add sounds
        this.load.audio('click', '/bonez/sounds/click.mp3');
        // this.load.audio('win-day1', '/bonez/sounds/win-day1.mp3');
        // this.load.audio('win-day2', '/bonez/sounds/winbanjo.mp3');
        // this.load.audio('win-day3', '/bonez/sounds/winbrass.mp3');
        // this.load.audio('win-day4', '/bonez/sounds/windoot.mp3');
        // this.load.audio('win-day5', '/bonez/sounds/winfantasia.mp3');
        // this.load.audio('win-day6', '/bonez/sounds/winfretless.mp3');
    }
    async create() {
        this.time.addEvent({
            delay: 500,
            callback: this.checkForVolumeChange,
            loop: true
        });

        // fade in the scene
        this.cameras.main.fadeIn(500, 0, 0, 0);
        this.cameras.main.setBackgroundColor('#081733');

        // add text
        this.add.text(200, 200, 'Loading...', { fontFamily: 'Truculenta', fontSize: 164, color: '#ffffff' });


        // Get server data here and then transition to the next scene
        this.DailyRewardStatus = await this.getDailyRewardStatus();
        
        //smooth transition to next scene
        this.cameras.main.fadeOut(500, 0, 0, 0);

        // once fade out is completed go to main scene
        this.cameras.main.once(Phaser.Cameras.Scene2D.Events.FADE_OUT_COMPLETE, () => {
            if (this.DailyRewardStatus.dailyCounter < 5){
                this.scene.start('DailyBonus', {dailyRewardStatus : this.DailyRewardStatus});
            }
            else {
                this.scene.start('DailyBigBonus', {dailyRewardStatus : this.DailyRewardStatus});
            }
        })
    }
}